import { decodeUUID, type UUID } from './uuid'
import type { InstructionVersionPayload } from '@/store/types'

export type InstructionVersion = {
  id: UUID
  instructionId: UUID
  content: string
  insertedAt: string
  authorId: number
  active: boolean
  hasProcessingError: boolean
  isMultiModal: boolean
  isReadyForValidation: boolean
}

export const decodeInstructionVersion = (
  instructionVersionPayload: InstructionVersionPayload,
): InstructionVersion => ({
  id: decodeUUID(instructionVersionPayload.id),
  instructionId: decodeUUID(instructionVersionPayload.instruction_id),
  content: instructionVersionPayload.content,
  insertedAt: instructionVersionPayload.inserted_at,
  authorId: instructionVersionPayload.author_id,
  active: instructionVersionPayload.active,
  hasProcessingError: instructionVersionPayload.has_processing_error,
  isMultiModal: instructionVersionPayload.multi_modal,
  isReadyForValidation: instructionVersionPayload.ready_for_validation,
})
